// extracted by mini-css-extract-plugin
export var border = "_5g-b";
export var circle = "_5g-3";
export var circleInner = "_5g-5";
export var disabled = "_5g-1";
export var focused = "_5g-a";
export var md = "_5g-8";
export var radioButton = "_5g-0";
export var radioInput = "_5g-2";
export var selected = "_5g-9";
export var sm = "_5g-7";
export var text = "_5g-4";
export var xs = "_5g-6";